import React from "react";

interface PrimaryButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
  /** @deprecated Continuar stays full-colour; validation happens on submit. Kept for call-site compat. */
  isValid?: boolean;
  children: React.ReactNode;
  loadingLabel?: string;
}

export function PrimaryButton({
  isLoading = false,
  isValid: _isValid = true,
  children,
  disabled,
  loadingLabel,
  className = "",
  ...props
}: PrimaryButtonProps) {
  void _isValid;
  const LoadingSpinner = () => (
    <svg
      className="animate-spin h-5 w-5 text-white"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      role="status"
      aria-label="Loading"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      ></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
      ></path>
    </svg>
  );

  const isDisabled = disabled || isLoading;

  return (
    <button
      disabled={isDisabled}
      aria-busy={isLoading}
      className={`w-full h-[50px] text-white text-lg leading-6 font-medium rounded-full flex items-center justify-center transition-colors bg-[#2D55FB] ${
        isDisabled ? "cursor-not-allowed" : "hover:bg-[#2347E8]"
      } ${className}`}
      style={{ fontFamily: "TT Commons Pro" }}
      {...props}
    >
      {isLoading ? (
        <>
          <LoadingSpinner />
          {loadingLabel && <span className="ml-2">{loadingLabel}</span>}
        </>
      ) : (
        children
      )}
    </button>
  );
}
